import {Injectable} from '@angular/core';
import {WizardNestedFormService} from '../abstract/wizard-nested-form-service';
import {FormBuilder, Validators} from '@angular/forms';
import {WizardValidators} from '../../wizard-validators';
import {WizardEnums} from '../../../wizard.namespace';
import {map, takeUntil} from 'rxjs/operators';
import {WizardFormEventsService} from '../wizard-form-events.service';
import {LaboratoryDocumentsProvider} from '@providers/laboratory-documents/laboratory-documents.provider';
import {LaboratoryDocument} from '@models/laboratory-document';
import {LaboratoryDocumentsNamespace} from '@components/laboratory-documents/laboratory-documents.namespace';

@Injectable()
export class LaboratoryTypeService extends WizardNestedFormService {
    form = this.fb.group({
        _touched: [false, Validators.requiredTrue],

        /**
         * Тип лаборатории
         */
        type: [WizardEnums.LaboratoryTypes.lnk, WizardValidators.required()],

        /**
         * Формат документации
         */
        document_format: [WizardEnums.DocumentsTypes.sdank01, WizardValidators.required()],

        /**
         * Тип аттестации (новая или действующая лаборатория)
         */
        attestation_type: [WizardEnums.LaboratoryAttestationTypes.new, WizardValidators.required()],

        order_number: ['', [
            WizardValidators.required('Номер приказа о создании лаборатории'),
        ]],
        order_date: ['', [
            WizardValidators.required('Дата приказа создании лаборатории'),
            WizardValidators.date(),
        ]],

        has_documents: [false, WizardValidators.requiredTrue()],
    });

    constructor(
        private fb: FormBuilder,
        private wizardFormEvents: WizardFormEventsService,
        private laboratoryDocumentsProvider: LaboratoryDocumentsProvider,
    ) {
        super();
    }

    init() {
        this.wizardFormEvents.laboratoryAttestationType$.pipe(
            takeUntil(this.destroyed$)
        ).subscribe((type) => {
            if (+type === WizardEnums.LaboratoryAttestationTypes.existed) {
                this.form.get('order_number').enable();
                this.form.get('order_date').enable();
                this.form.get('has_documents').enable();
            } else {
                /**
                 * Дизейблим поля, чтобы валидаторы на них не срабатывали
                 */
                this.form.get('order_number').disable();
                this.form.get('order_date').disable();
                this.form.get('has_documents').disable();
            }
        });

        /**
         * При изменении типа аттестации лаборатории обязательность полей меняется
         */
        this.form.get('attestation_type').valueChanges.pipe(
            takeUntil(this.destroyed$)
        ).subscribe((type) => {
            this.wizardFormEvents.setLaboratoryAttestationType(type);
        });
        this.form.get('attestation_type').updateValueAndValidity();

        /**
         * Будем проверять наличие нужных документов лаборатории
         */
        this.laboratoryDocumentsProvider.laboratoryDocuments$.pipe(
            takeUntil(this.destroyed$),
        ).subscribe((attestationList: LaboratoryDocument[]) => {
            this.form.get('has_documents').patchValue(Boolean(attestationList.length));
        });
    }

    restoreValidators() {

    }
}
